<template>
    <ai-form-text-box ref="dnumRef" :callbacks="callbacks" :meta="meta" />
</template>
<script setup>
import AiFormTextBox from '@/components/card-component/ai-form-text-box.vue';
import { inject, onMounted, ref } from 'vue';

const userData = inject('userData');
const dnumRef = ref();
const props = defineProps({
    meta: {
        type: Object,
        default: () => {},
    },
    callbacks: {
        type: Object,
        default: () => ({ userDataChanged: null }),
    },
});
const handleBlur = () => {
    if (!userData.value['sname'] && !userData.value['fname']) {
        Object.assign(userData.value, { sname: userData.value['dnum'], fname: userData.value['dnum'] });
        props.callbacks.userDataChanged();
    }
};
onMounted(() => {
    dnumRef.value?.aiTextBoxRef?.textBoxRef?.instance.on('focusOut', handleBlur);
});
</script>
